/* PDP Clareador v2 (sections/clv2-pdp.liquid). Kit + adicionais, totais, compra,
   barra fixa, carrosséis com pontos, stories em vídeo e contadores. */
(function () {
  var root = document.querySelector('[data-cl2]');
  if (!root) return;

  var PARC = 1.22676 / 12;    /* fator da casa para 12x no cartão */

  /* ── header próprio: vai para o início do body (assim gruda no topo da página inteira) ── */
  var hdr = document.querySelector('[data-cl2h]');
  if (hdr) {
    if (hdr.parentElement !== document.body) document.body.insertBefore(hdr, document.body.firstChild);
    var hBar = hdr.querySelector('[data-cl2h-bar]');
    var hStuck = function () { hBar.classList.toggle('is-stuck', window.scrollY > 40); };
    window.addEventListener('scroll', hStuck, { passive: true });
    hStuck();

    var drawer = hdr.querySelector('[data-cl2h-drawer]');
    var hOpen = hdr.querySelector('[data-cl2h-open]');
    var openDrawer = function () {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      hOpen.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var x = drawer.querySelector('[data-cl2h-close]');
      if (x) x.focus({ preventScroll: true });
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      hOpen.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 260);
      hOpen.focus({ preventScroll: true });
    };
    hOpen.addEventListener('click', openDrawer);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('[data-cl2h-close]')) closeDrawer();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });

    /* carrinho: abre a gaveta do app (Section Store) quando ela existe; senão segue para /cart */
    var hCart = hdr.querySelector('[data-cl2h-cart]');
    hCart.addEventListener('click', function (e) {
      if (window.SectionStoreCart && typeof window.SectionStoreCart.open === 'function') {
        e.preventDefault();
        e.stopPropagation();
        window.SectionStoreCart.open();
      }
    });
    var hCount = hdr.querySelector('[data-cl2h-count]');
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        hCount.textContent = c.item_count;
        hCount.hidden = !c.item_count;
        hCart.setAttribute('aria-label', 'Carrinho, ' + c.item_count + ' itens');
      })
      .catch(function () {});
  }

  function money(c) {
    var v = (Math.round(c) / 100).toFixed(2).split('.');
    return 'R$ ' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }
  function setAll(sel, txt) {
    document.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; });
  }

  /* ── kit + adicionais ── */
  var kits = [].slice.call(root.querySelectorAll('.cl2-kit input'));
  var adds = [].slice.call(root.querySelectorAll('.cl2-addc input'));

  function currentKit() {
    var k = kits.filter(function (i) { return i.checked; })[0];
    if (!k) {
      k = kits.filter(function (i) { return !i.disabled; })[0];
      if (k) k.checked = true;
    }
    return k;
  }

  function update() {
    var k = currentKit();
    if (!k) return;
    kits.forEach(function (i) { i.closest('.cl2-kit').classList.toggle('is-on', i.checked); });
    adds.forEach(function (i) { i.closest('.cl2-addc').classList.toggle('is-on', i.checked); });

    var kp = +k.dataset.price, kc = +k.dataset.compare || kp;
    var tot = kp, was = kc;
    adds.forEach(function (i) {
      if (!i.checked) return;
      tot += +i.dataset.price;
      was += (+i.dataset.compare || +i.dataset.price);
    });
    var eco = Math.max(0, was - tot);

    /* topo = preço do kit escolhido; total, economia e barra fixa = kit + adicionais */
    setAll('[data-cl2-parc]', money(kp * PARC));
    setAll('[data-cl2-full]', money(kp));
    setAll('[data-cl2-off]', kc > kp ? Math.round((kc - kp) * 100 / kc) + '% OFF' : '');
    setAll('[data-cl2-s-parc]', money(tot * PARC));
    setAll('[data-cl2-s-full],[data-cl2-total]', money(tot));
    root.querySelectorAll('[data-cl2-frete]').forEach(function (el) { el.hidden = tot < 19900; });
    setAll('[data-cl2-was],[data-cl2-s-was]', eco > 0 ? money(was) : '');
    setAll('[data-cl2-eco]', money(eco));
    setAll('[data-cl2-ecop]', was > 0 ? Math.round(eco * 100 / was) : 0);
    var save = root.querySelector('[data-cl2-save]');
    if (save) save.style.display = eco > 0 ? '' : 'none';
  }
  kits.concat(adds).forEach(function (i) { i.addEventListener('change', update); });
  update();

  /* ── compra: carrinho (dispara os eventos de add to cart) e checkout ── */
  function limparCupom() {
    var host = location.hostname.replace(/^www\./, '');
    ['', '; domain=' + host, '; domain=.' + host].forEach(function (d) {
      document.cookie = 'discount_code=; Max-Age=0; path=/' + d;
    });
  }
  var buying = false;
  function buy(btn) {
    if (buying) return;
    var k = currentKit();
    if (!k) return;
    var items = [{ id: +k.value, quantity: 1 }];
    adds.forEach(function (i) { if (i.checked) items.push({ id: +i.value, quantity: 1 }); });
    /* LP: cada kit tem o seu cupom no radio. PDP: um cupom para a pagina inteira. */
    var pageDiscount = k.dataset.discount || root.dataset.cl2PageDiscount || '';
    var addonDiscount = items.length > 1 ? (pageDiscount ? 'CLAREADORPDPADD20' : 'KIT20C-' + (items.length - 1)) : '';
    var cupom = [pageDiscount, addonDiscount].filter(Boolean).join(',');
    var permalink = '/cart/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(',') + (cupom ? '?discount=' + cupom : '');

    buying = true;
    root.querySelectorAll('[data-cl2-buy]').forEach(function (b) { b.disabled = true; });
    var label = btn.textContent;
    btn.textContent = 'Indo para o pagamento...';

    /* _section_store_cart=1: sem a marca o app do carrinho abre a gaveta por cima */
    fetch('/cart/add.js?_section_store_cart=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: cupom })
      }).catch(function () {});
    }).then(function () {
      limparCupom();
      window.location.href = '/checkout?locale=pt-BR';
    }).catch(function () {
      limparCupom();
      window.location.href = permalink;
    });

    setTimeout(function () {
      buying = false;
      btn.textContent = label;
      root.querySelectorAll('[data-cl2-buy]').forEach(function (b) { b.disabled = false; });
    }, 8000);
  }
  root.querySelectorAll('[data-cl2-buy]').forEach(function (b) {
    b.addEventListener('click', function () { buy(b); });
  });

  /* ── barra fixa: aparece quando a área de compra sai da tela (acima ou abaixo) ── */
  var sticky = root.querySelector('[data-cl2-sticky]');
  var offer = root.querySelector('.cl2-offer');
  if (sticky && offer) {
    var stBtn = sticky.querySelector('button'), stOn = null, stRaf;
    var checkSticky = function () {
      var r = offer.getBoundingClientRect();
      var show = r.bottom < 0 || (r.top > window.innerHeight && window.scrollY > 200);
      if (show === stOn) return;
      stOn = show;
      sticky.classList.toggle('is-on', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      stBtn.tabIndex = show ? 0 : -1;
      document.documentElement.classList.toggle('cl2-bar-on', show);
    };
    window.addEventListener('scroll', function () {
      cancelAnimationFrame(stRaf);
      stRaf = requestAnimationFrame(checkSticky);
    }, { passive: true });
    window.addEventListener('resize', checkSticky);
    checkSticky();
  }

  /* ── carrosséis com pontos (galeria no celular, ensaio) ── */
  document.querySelectorAll('.cl2 [data-cl2-slider]').forEach(function (track) {
    var dots = track.parentElement.querySelector('[data-cl2-dots]');
    var items = track.children;
    if (!dots || items.length < 2) { if (dots) dots.style.display = 'none'; return; }
    for (var i = 0; i < items.length; i++) {
      var d = document.createElement('span');
      d.className = 'cl2-dot' + (i === 0 ? ' is-on' : '');
      dots.appendChild(d);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = items[0].getBoundingClientRect().width || 1;
        var idx = Math.round(track.scrollLeft / (w + 10));
        [].forEach.call(dots.children, function (d, j) { d.classList.toggle('is-on', j === idx); });
      });
    }, { passive: true });
  });

  /* ── stories: vídeo em tela cheia ── */
  var modal = root.querySelector('[data-cl2-modal]');
  var video = modal && modal.querySelector('[data-cl2-video]');
  function closeModal() {
    if (!modal) return;
    video.pause();
    video.removeAttribute('src');
    video.load();
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }
  root.querySelectorAll('[data-cl2-story]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!modal) return;
      video.poster = b.dataset.poster || '';
      video.src = b.dataset.cl2Story;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
  });
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-cl2-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
  }

  /* ── avaliações: filtro por região + "ver mais" ── */
  var revGrid = root.querySelector('[data-cl2-revs]');
  if (revGrid) {
    var revCards = [].slice.call(revGrid.children);
    var revMore = root.querySelector('[data-cl2-revmore]');
    var revFilter = 'todas', revLimit = 6, STEP = 6;
    var renderRevs = function () {
      var match = revCards.filter(function (c) {
        return revFilter === 'todas' || (' ' + c.dataset.r + ' ').indexOf(' ' + revFilter + ' ') > -1;
      });
      revCards.forEach(function (c) { c.hidden = true; });
      match.forEach(function (c, i) { c.hidden = i >= revLimit; });
      if (revMore) revMore.hidden = match.length <= revLimit;
    };
    root.querySelectorAll('[data-cl2-rf]').forEach(function (b) {
      b.addEventListener('click', function () {
        revFilter = b.dataset.cl2Rf;
        revLimit = STEP;
        root.querySelectorAll('[data-cl2-rf]').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        renderRevs();
      });
    });
    if (revMore) revMore.addEventListener('click', function () { revLimit += STEP; renderRevs(); });
    renderRevs();
  }

  /* ── imagens ampliáveis: galeria do topo (com navegação) e fotos das avaliações ── */
  var lb = root.querySelector('[data-cl2-lb]');
  if (lb) {
    var lbImg = lb.querySelector('[data-cl2-lbimg]');
    var lbPrev = lb.querySelector('[data-cl2-lbprev]');
    var lbNext = lb.querySelector('[data-cl2-lbnext]');
    var lbCount = lb.querySelector('[data-cl2-lbcount]');
    var lbList = [], lbIdx = 0, lbBack = null;
    var showLb = function () {
      var b = lbList[lbIdx];
      lbImg.src = b.dataset.cl2Img;
      var inner = b.querySelector('img');
      lbImg.alt = inner ? inner.alt : '';
      var many = lbList.length > 1;
      lbPrev.hidden = lbNext.hidden = lbCount.hidden = !many;
      if (many) lbCount.textContent = (lbIdx + 1) + ' / ' + lbList.length;
    };
    var openLb = function (b) {
      var g = b.dataset.cl2Group;
      lbList = g ? [].slice.call(root.querySelectorAll('[data-cl2-img][data-cl2-group="' + g + '"]')) : [b];
      lbIdx = Math.max(0, lbList.indexOf(b));
      lbBack = b;
      showLb();
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      lb.querySelector('[data-cl2-lbclose]').focus({ preventScroll: true });
    };
    var closeLb = function () {
      lb.hidden = true;
      lbImg.src = 'data:,';
      document.documentElement.style.overflow = '';
      if (lbBack) lbBack.focus({ preventScroll: true });
    };
    var stepLb = function (d) {
      if (lbList.length < 2) return;
      lbIdx = (lbIdx + d + lbList.length) % lbList.length;
      showLb();
    };
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-cl2-img]');
      if (b) openLb(b);
    });
    var galZoom = root.querySelector('[data-cl2-galzoom]');
    if (galZoom) galZoom.addEventListener('click', function () {
      var track = root.querySelector('.cl2-gal__track');
      var items = track.querySelectorAll('[data-cl2-img]');
      var w = track.children[0] ? track.children[0].getBoundingClientRect().width : 1;
      var i = Math.min(items.length - 1, Math.round(track.scrollLeft / (w + 10)));
      if (items[i]) openLb(items[i]);
    });
    lbPrev.addEventListener('click', function () { stepLb(-1); });
    lbNext.addEventListener('click', function () { stepLb(1); });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('[data-cl2-lbclose]')) closeLb();
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') stepLb(-1);
      else if (e.key === 'ArrowRight') stepLb(1);
    });
    var tx = null;
    lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (tx === null) return;
      var dx = e.changedTouches[0].clientX - tx;
      tx = null;
      if (Math.abs(dx) > 45) stepLb(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ── contadores: sobem de 0 quando entram na tela (o HTML já vem com o número final) ── */
  var nums = root.querySelectorAll('[data-cl2-count]');
  if (nums.length && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, end = +el.dataset.cl2Count, t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / 1100);
          el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))) + '%';
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
  }
})();
